export function getUrlKey (name) {
  let href = location.href
  try {
    href = decodeURIComponent(href)
  } catch (err) {
    href = location.href
  }
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(href) || [, ''])[1].replace(/\+/g, '%20')) || null
}
